// extracted by mini-css-extract-plugin
module.exports = {"body":"PartnerLoan_body__2qNZJ","form":"PartnerLoan_form__2ljd3","phones":"PartnerLoan_phones__1jSrv"};